import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MenuModal from "./MenuModal";
import {
    fetchAllMenus,
    toggleMenuStatus,
} from "../../../Redux/slice/features/menuSlice";

const MenuList = () => {
    const dispatch = useDispatch();
    const { adminMenus, actionLoading } = useSelector((state) => state.menu);
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [openMenus, setOpenMenus] = useState({});

    useEffect(() => {
        dispatch(fetchAllMenus());
    }, [dispatch]);

    const toggleMenu = (id) => {
        setOpenMenus((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const handleEdit = (menu) => {
        setEditData(menu);
        setShowModal(true);
    };
    
    // console.log("MENU DATA:", adminMenus);

    // TOGGLE ACTIVE/INACTIVE
    const handleToggleStatus = async (id) => {
        if (actionLoading) return;

        const res = await dispatch(toggleMenuStatus(id));

        if (res.meta.requestStatus === "fulfilled") {
            alert("Menu status updated successfully");

            // HARD REFRESH
            window.location.reload();
        } else {
            alert("Failed to update menu status");
        }
    };

    const renderAccordion = (menus, level = 0) => {
        return menus.map((menu) => {
            const hasChildren =
                Array.isArray(menu.children) && menu.children.length > 0;
            const isOpen = openMenus[menu.intMenuId];

            const isActive =
                Number(menu.bitStatus) === 1;

            return (
                <div
                    key={menu.intMenuId}
                    style={{ marginLeft: `${level * 10}px` }}
                >

                    {/* HEADER */}
                    <div
                        className="d-flex justify-content-between align-items-center p-2 mb-2 border rounded bg-light"
                        style={{ cursor: hasChildren ? "pointer" : "default" }}
                        onClick={() => hasChildren && toggleMenu(menu.intMenuId)}
                    >
                        <div className="d-flex align-items-center gap-2">

                            {hasChildren && (
                                <span style={{ fontSize: "12px", width: "12px" }}>
                                    {isOpen ? "▼" : "▶"}
                                </span>
                            )}

                            {level === 0 && menu.vchIconSvg && (
                                <span dangerouslySetInnerHTML={{ __html: menu.vchIconSvg }} />
                            )}

                            <strong>{menu.vchMenuName}</strong>

                            {menu.vchPermissionCode && (
                                <span className="badge bg-info text-dark ms-2">
                                    {menu.vchPermissionCode}
                                </span>
                            )}
                        </div>

                        <div className="d-flex align-items-center gap-2 ms-auto">

                            <span
                                className={`badge ${isActive ? "bg-success" : "bg-secondary"
                                    }`}
                            >
                                {isActive ? "Active" : "Inactive"}
                            </span>

                            {/* TOGGLE SWITCH */}
                            <div className="form-check form-switch m-0">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isActive}
                                    disabled={actionLoading}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        handleToggleStatus(menu.intMenuId);
                                    }}
                                />
                            </div>

                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit(menu);
                                }}
                            >
                                Edit
                            </button>

                        </div>

                    </div>

                    {/* CHILDREN */}
                    {hasChildren && isOpen && (
                        <div
                            className="ms-3 ps-3"
                            style={{
                                borderLeft: "2px dashed #ccc",
                            }}
                        >
                            {renderAccordion(menu.children, level + 1)}
                        </div>
                    )}

                </div>
            );
        });
    };

    return (
        <div className="container">

            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h4 className="fw-bold mb-0">Menu Management</h4>
                    <small className="text-muted">
                        Manage sidebar structure and permissions
                    </small>
                </div>

                <button
                    className="btn btn-primary"
                    onClick={() => setShowModal(true)}
                >
                    + Add Menu
                </button>
            </div>

            {/* ACCORDION */}
            <div>{renderAccordion(adminMenus)}</div>

            {/* MODAL */}
            {showModal && (
                <MenuModal
                    editData={editData}
                    onClose={() => {
                        setShowModal(false);
                        setEditData(null);
                    }}
                />
            )}
        </div>
    );
};

export default MenuList;